// extracted by mini-css-extract-plugin
module.exports = {"Page":"DiscoveryCategoriesDetails_Page__4ogCI","NameGroup":"DiscoveryCategoriesDetails_NameGroup__2LCce"};